const allVouch = { data: [], loading: true };

export const GetAllSubmittedVouchers = (state = allVouch, action) => {
  switch (action.type) {
    case "get_submittedVouch":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
